const theme = {
	images: {
		logo: "https://storage.googleapis.com/common-library/header-footer/assets/logo.png",
		isotipo: "https://cdn1.infocasas.com.uy/web/67649e6921e7d_yapo-iso.png",
		favicon: "https://cdn1.infocasas.com.uy/web/67649e86088fe_favicon_yapo.ico",
		icono: "https://cdn1.infocasas.com.uy/web/67649e6921e7d_yapo-iso.png",
	},
	fontFamily: "DM Sans, Muli, sans-serif",
	colors: {
		primaryColor: "#fb6907",
		primaryDarkColor: "#fb6907",
		primaryHoverColor: "rgba(235, 137, 0, 0.7)",
		primaryLightColor: "#F1C84D",
		secondaryColor: "#2D81BE",
		primaryColorV2: '#0A558B',
		secondaryDarkColor: "#0A558B",
		secondaryHoverColor: "#0A558B",
		secondaryOpacityColor: "rgba(45, 129, 190, 0.5)",
		textColorHigh: "#000000",
		textColorMedium: "#484848",
		textColorLow: "#8A8A8A",
		textSecondaryColor: "#808080",
		textOnSecondaryColor: "#fff",
		textInverseColor: "#a7a7a7",
		textHoverColor: "#fff",
		textLinkSecondary: "#2D81BE",
		backgroundColor: "#fff",
		backgroundMainColor: "#2D81BE",
		backgroundModalColor: "rgba(0, 0, 0, 0.5)",
		backgroundMenuColor: "#FFFFFF",
		textMenuColor: "#000000",
		linkColor: "#2D81BE",
		linkHoverColor: "#0A558B",
		backgroundColorAternative: "#F2F6FD",
		borderColor: "#E9E9E9",
		favoriteColor: "#ff6767",
		successColor: "#69AD6C",
		errorColor: "#F24E1E",
		warningColor: "#fff3cd",
		placeholderTextColor: "#cccccc",
		contentButtonColor: "#0A558B",
		backgroundHighColor: "#FF4A1E",
		backgroundMediumColor: "#FF8500",
	},
	breakPoints: {
		xs: "576px",
		sm: "576px",
		md: "768px",
		lg: "992px",
		xl: "1200px",
		xxl: "1600px",
	},
	headerHeight: 64,
	spacing: {
		xsSpacing: 4,
		smSpacing: 8,
		mdSpacing: 12,
		lgSpacing: 16,
		xlSpacing: 24,
		xxlSpacing: 32,
	},
	fontSizes: {
		baseFontSize: "16px",
		baseLineHeight: 1.5,

		lgFontSize: "16px",
		smFontSize: "13px",
		xsFontSize: "11px",

		xlTitle: "32px",
		xlLineHeight: "40px",
		lgTitle: "28px",
		lgLineHeight: "36px",
		mdTitle: "24px",
		mdLineHeight: "32px",
		smTitle: "20px",
		smLineHeight: "28px",
		xsTitle: "18px",
		xsLineHeight: "24px",
	},
};

module.exports = theme;